import { render, staticRenderFns } from "./ProductCategoryLookup.vue?vue&type=template&id=24fa035b&scoped=true&"
import script from "./ProductCategoryLookup.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryLookup.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategoryLookup.vue?vue&type=style&index=0&id=24fa035b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fa035b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VListItemContent,VListItemTitle})
